import React from 'react';
import styled from 'styled-components';
import { OSM, Vector as VectorSource } from 'ol/source';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import OlMap from 'ol/Map';
import View from 'ol/View';
import { Polygon } from 'ol/geom';

import Feature from 'ol/Feature';
import PropTypes from 'prop-types';
import { vectorLayerStyle } from '../../containers/SelectArea/styles';

const Wrapper = styled.div`
  width: 100%;
  height: 200px;
`;

class SelectedAreaDisplayer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      featureDrawn: false,
    };

    this.png = null;
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    const {
      coords,
    } = this.props;

    this.initializeMap();

    if (coords) {
      this.drawFeatureAndZoomToMap(coords);
      // This is needed because otherwise this component won't work in a modal
      this.olmap.updateSize();
    }
  }

  componentDidUpdate() {
    const {
      coords,
    } = this.props;

    if (coords) {
      this.drawFeatureAndZoomToMap(coords);
      // This is needed because otherwise this component won't work in a modal
      this.olmap.updateSize();
    }
  }

  generatePNG = () => {
    const mapCanvas = document.createElement('canvas');
    const size = this.olmap.getSize();
    mapCanvas.width = size[0];
    mapCanvas.height = size[1];
    const mapContext = mapCanvas.getContext('2d');
    Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), (canvas) => {
      if (canvas.width > 0) {
        const opacity = canvas.parentNode.style.opacity;
        mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
        const transform = canvas.style.transform;
        // Get the transform parameters from the style's transform matrix
        const matrix = transform.match(/^matrix\(([^\(]*)\)$/)[1].split(',').map(Number);
        // Apply the transform to the export map context
        CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
        mapContext.drawImage(canvas, 0, 0);
      }
    });

    if (this.props.getPNG) {
      this.props.getPNG(mapCanvas.toDataURL());
    }
  }

  initializeMap = () => {
    this.source = new VectorSource();
    this.vector = new VectorLayer({
      source: this.source,
      style: vectorLayerStyle,
    });

    const raster = new TileLayer({
      source: new OSM(),
    });

    this.olmap = new OlMap({
      layers: [raster, this.vector],
      interactions: [],
      controls: [],
      target: null,
      view: null,
    });

    this.olmap.once('rendercomplete', this.generatePNG);
  }

  drawFeatureAndZoomToMap = (coords) => {
    const {
      featureDrawn,
    } = this.state;

    if (featureDrawn) {
      return;
    }

    this.olmap.setTarget(this.mapRef.current);

    const feature = new Feature({
      geometry: new Polygon([coords]),
    });

    this.source.addFeature(feature);

    const ext = feature.getGeometry().getExtent();

    this.olmap.setView(new View());
    this.olmap.getView().fit(ext, this.olmap.getSize());

    this.setState({
      featureDrawn: true,
    });
  }

  render() {
    return (
      <Wrapper
        ref={this.mapRef}
      />
    );
  }
}

SelectedAreaDisplayer.propTypes = {
  coords: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.number,
    ),
  ),
  getPNG: PropTypes.func,
};

SelectedAreaDisplayer.defaultProps = {
  coords: null,
  getPNG: null,
};

export default SelectedAreaDisplayer;
